import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';
import { t } from '../../../utils/translations';

const CategorySelector = ({ 
  selectedCategory, 
  onCategoryChange, 
  error,
  disabled = false 
}) => {
  const categoryOptions = [
    { 
      value: 'board', 
      label: t('officeFormComponents.boardMembers'),
      description: t('officeFormComponents.boardMembersDesc')
    },
    { 
      value: 'supervisory', 
      label: t('officeFormComponents.supervisoryCommittee'),
      description: t('officeFormComponents.supervisoryCommitteeDesc')
    },
    { 
      value: 'electoral', 
      label: t('officeFormComponents.electoralCommittee'),
      description: t('officeFormComponents.electoralCommitteeDesc')
    },
    { 
      value: 'general_assembly', 
      label: t('officeFormComponents.generalAssembly'),
      description: t('officeFormComponents.generalAssemblyDesc')
    },
    { 
      value: 'offices', 
      label: t('officeFormComponents.administrativeOffices'),
      description: t('officeFormComponents.administrativeOfficesDesc')
    }
  ];

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'board':
        return 'Crown';
      case 'supervisory':
        return 'Shield';
      case 'electoral':
        return 'Vote';
      case 'general_assembly':
        return 'Users';
      case 'offices':
        return 'Briefcase';
      default:
        return 'Building2';
    }
  };

  const getCategoryDescription = (category) => {
    const option = categoryOptions?.find(opt => opt?.value === category);
    return option?.description || '';
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon 
            name={getCategoryIcon(selectedCategory)} 
            size={20} 
            className="text-primary"
          />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground font-arabic">
            {t('officeFormComponents.officeCategory')}
          </h3>
          <p className="text-sm text-muted-foreground">
            {t('officeFormComponents.selectOrganizationalCategory')}
          </p>
        </div>
      </div>
      <Select
        label={t('officeFormComponents.positionCategory')}
        description={t('officeFormComponents.chooseAppropriateCategory')}
        options={categoryOptions}
        value={selectedCategory}
        onChange={onCategoryChange}
        error={error}
        disabled={disabled}
        required
        placeholder={t('officeFormComponents.selectCategory')}
        className="w-full"
      />
      {selectedCategory && (
        <div className="p-4 bg-muted/50 rounded-lg border border-border">
          <div className="flex items-start space-x-3">
            <Icon 
              name="Info" 
              size={16} 
              className="text-accent mt-0.5 flex-shrink-0"
            />
            <div>
              <p className="text-sm font-medium text-foreground">
                {categoryOptions?.find(opt => opt?.value === selectedCategory)?.label}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                {getCategoryDescription(selectedCategory)}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategorySelector;